import { z } from "zod"

export const signInRequestSchema = z.object({
  username: z.string().trim(),
  password: z.string().trim(),
})

export type SignInSchema = z.infer<typeof signInRequestSchema>
